import { useState, useEffect } from 'react'
import { fetchLegendData } from '../helpers/fetchLegendData';

export const useFetchLegend = ( geoserverUrl, layerName, styleName ) => {

    const [legendData, setLegendData] = useState('');
    
    useEffect( () => {
        fetchLegendData( geoserverUrl, layerName, styleName )
            .then( data => {                
                setLegendData(data);
            })
    }, [styleName])
    return legendData;
}